import axios from 'axios';

export const api = axios.create({
    baseURL: '/vaal-auth',
    headers: {
        'Content-Type': 'application/json'
    },
})